import { HYDRATE } from 'next-redux-wrapper';

import { EAvailability } from '@r1-frontend/api-domru/api-loyalty/v1/program/availability';
import { IInfo } from '@r1-frontend/api-domru/api-loyalty/v1/program/info';

import { InferValueTypes, THydrateAction } from '~/src/store';
import * as ActionCreators from '~/src/store/actionCreators/loyalty';
import { LOYALTY_AVAILABILITY, LOYALTY_INFO } from '~/src/store/actionTypes/loyalty';

export interface IAvailiabilityData {
    available: EAvailability,
    isAvailable: boolean,
    isRegistered: boolean,
}

export interface ILoyaltyState {
    availability: IAvailiabilityData,
    info: IInfo,
}

const initialState: ILoyaltyState = {
    availability: {
        available: EAvailability.UNAVAILABLE,
        isAvailable: false,
        isRegistered: false,
    },
    info: {
        loyaltyNumber: '',
        loyaltyLevel: 0,
        nextLevelDate: '',
        loyaltyCash: 0,
        bonuses: 0,
        expireDate: '',
        expireBonuses: 0,
        progressBar: 0,
        registrationDate: '',
        cashbackPercentAfterLevelUp: 0,
        maxLoyaltyCash: 0,
    },
};

type TActions = ReturnType<InferValueTypes<typeof ActionCreators>> | THydrateAction;

const loyaltyReducer = (state = initialState, action: TActions): ILoyaltyState => {
    switch (action.type) {
        case HYDRATE:
            return action.payload.loyalty;
        case LOYALTY_AVAILABILITY:
            return { ...state, availability: action.payload };
        case LOYALTY_INFO:
            return { ...state, info: action.payload };
        default:
            return state;
    }
};

export default loyaltyReducer;
